interface SiteElementFilterArrayDropdownRendererConfig {
    isSingleSelect: boolean;
}

class SiteElementFilterArrayDropdownRenderer
    extends QueryElement<HTMLElement>
    implements ISiteElementFilterRenderer, ISiteElementCheckItem {
    
    private readonly _filter: SiteElementFilterArray;
    private readonly _value: ISiteFilterItem;
    private readonly _config: SiteElementFilterArrayDropdownRendererConfig;
    private readonly _clear: SiteElementButton;
    private readonly _type: SiteElementFilterArrayTypes;
    
    constructor(filter: SiteElementFilterArray, value: ISiteFilterItem, type: SiteElementFilterArrayTypes) {
        super(document.createElement("DIV"));

        this._filter = filter;
        this._value = value;
        this._type = type;
        this._config = this._filter.getConfig<SiteElementFilterArrayDropdownRendererConfig>({
            isSingleSelect: false
        });
        
        this.addClass("element-filter-dropdown")
            .addClass("element-hover");

        var header = QueryElement.QueryElement("H2")
            .addClass("element-hover-close")
            .setText(value.name);
    
        this.append(header);

        // Append clear button
        let clear = new SiteElementButton({
            "icon": "clear",
            "title": ""
        });
        clear.addClass("reset");
        clear.on("click", () => {
            this._filter.removeValues();
            this._filter.updateFilterModel(true);
        });
        this.append(clear);
        this._clear = clear;

        this.append(this.renderChilds(value.items));
        this.checkFilter();

        var element = this.get();
        if (element == null)
            throw "Element not found";
        
        new SiteElementHover(element);
    }

    addValue(value: ISiteFilterItemValue): void {
        if (this._config.isSingleSelect) {
            this._filter.removeValues();
            this.query(".element-filter-checkitem")
                .all<SiteElementCheckItem, any>(a => a.makeInactive());
        }
        
        this._filter.addValue(value.filterValue);
        this._filter.updateFilterModel(false);

        this.checkFilter();
    }
    removeValue(value: ISiteFilterItemValue): void {
        this._filter.removeValue(value.filterValue);
        this._filter.updateFilterModel(false);

        this.checkFilter();
    }
    containsValue(value: ISiteFilterItemValue): boolean {
        return this._filter.containsValue(value.filterValue);
    }

    checkFilter(): void {
        if (!this._filter.hasValue())
            this._clear.addClass("hidden");
        else
            this._clear.removeClass("hidden");
    }

    renderChilds(values: ISiteFilterItemValue[]) {
        let container = QueryElement.QueryElement("UL");
        
        for(let item of values) {
            let containerItem = QueryElement.QueryElement("LI");

            switch(this._type)
            {
                default:
                    new SiteElementCheckItem(this, item)
                        .appendTo(containerItem);
                    break;
                case  "color":
                    new SiteElementCheckColorItem(this, item as ISiteFilterColorItemValue)
                        .appendTo(containerItem);
                    break;
            }
            
            if (item.childs != null) {
                this.renderChilds(item.childs)
                    .appendTo(containerItem);
            }

            container.append(containerItem);
        }

        return container;
    }

    getState() {
        return null;
    }
}